import {
  ADD_INBOX_JOB,
  REMOVE_INBOX_JOB,
  ADD_INBOX_IN_PROCCESS,
  REMOVE_INBOX_IN_PROCCESS,
} from '@/store/mutation-types';
import { getInboxJobs } from '@/services/job-service';
import randomColor from '@/shared/utils/random-color';
import { alreadyExistsInboxJob } from '@/shared/utils/job-helpers';
import ContactService from '@/services/contact-service';

const actions = {
  async getInboxJobs({ dispatch }, agentId) {
    return await getInboxJobs(agentId).then((inboxJobs) => {
      if (typeof inboxJobs === 'string') return;
      Object.keys(inboxJobs).forEach((protocol) => {
        const job = inboxJobs[protocol];
        dispatch('newInboxJob', job);
      });
    });
  },

  async newInboxJob({ dispatch, rootState, commit }, job) {
    const alreadyExists = alreadyExistsInboxJob(
      job.protocol,
      rootState.jobs.inboxJobs,
    );
    if (!alreadyExists) {
      job.color = randomColor();
      job.contact = await ContactService.getById(job.contactId);
      job.contactIdentifier = job.whatsAppPhone;
      job.channel = 'WhatsApp';
      commit(ADD_INBOX_JOB, job);
    }
  },

  addInboxInProccess({ commit }, protocol) {
    commit(ADD_INBOX_IN_PROCCESS, protocol);
  },

  removeInboxInProccess({ commit }, protocol) {
    commit(REMOVE_INBOX_IN_PROCCESS, protocol);
  },

  removeInboxJob({ commit }, protocol) {
    commit(REMOVE_INBOX_JOB, protocol);
  },
};

export default actions;
